import { Column, Entity, PrimaryGeneratedColumn } from "typeorm";

@Entity('montly_mis')
export class MontlyMisEntity{
    @PrimaryGeneratedColumn('increment', {name: 'id'})
    id: number;

    // @Column('int',{
    //     name:'plant_id',
    //     nullable:false
    // })
    // plantId:number

    // @Column('datetime',{
    //     name:'date',
    //     nullable:false
    // })
    // date: Date

    // @Column('decimal',{
    //     name:'dispatched_qty',
    //     precision:10,scale:3,
    //     unsigned:true,
    // })
    // dispatchedQty : number

    // @Column('decimal',{
    //     name:'local_sales_kg',
    //     precision:10,scale:3,
    //     unsigned:true,
    // })
    // localSaleKg : number

    // @Column('decimal',{
    //     name:'lab_compliments_qty',
    //     precision:10,scale:3,
    //     unsigned:true,
    // })
    // labComplimentsQty : number

    // @Column('decimal',{
    //     name:'total_issues_qty',
    //     precision:10,scale:3,
    //     unsigned:true,
    // })
    // totalIssuesQty : number

    // @Column('decimal',{
    //     name:'fresh_prod_qty',
    //     precision:10,scale:3,
    //     unsigned:true,
    // })
    // freshProdQty : number

    // @Column('decimal',{
    //     name:'re_process_qty',
    //     precision:10,scale:3,
    //     unsigned:true,
    // })
    // reProcessQty : number

    // @Column('decimal',{
    //     name:'total_prod_qty',
    //     precision:10,scale:3,
    //     unsigned:true,
    // })
    // totalProductionQty : number

    // @Column('decimal',{
    //     name:'received_rm_purchase_qty',
    //     precision:10,scale:3,
    //     unsigned:true,
    // })
    // receivedRmPurchaseQty : number

    // @Column('decimal',{
    //     name:'procured_rm_purchase_qty',
    //     precision:10,scale:3,
    //     unsigned:true,
    // })
    // procuredRmPurchaseQty : number

    // @Column('decimal',{
    //     name:'rm_avg_price',
    //     precision:10,scale:3,
    //     unsigned:true,
    // })
    // rmAvgPrice : number

    // @Column('decimal',{
    //     name:'hon_fg_qty',
    //     precision:10,scale:3,
    //     unsigned:true,
    // })
    // honFgQty : number

    // @Column('decimal',{
    //     name:'fg_purchase_qty',
    //     precision:10,scale:3,
    //     unsigned:true,
    // })
    // fgPurchaseQty : number

    // @Column('decimal',{
    //     name:'transfer_qty',
    //     precision:10,scale:3,
    //     unsigned:true,
    // })
    // transferQty : number

    // @Column('decimal',{
    //     name:'hon_to_fg_yield',
    //     precision:10,scale:3,
    //     unsigned:true,
    // })
    // honToFgYield : number

    // @Column('decimal',{
    //     name:'hon_to_hl_yield',
    //     precision:10,scale:3,
    //     unsigned:true,
    // })
    // honToHlYield : number

    // @Column('decimal',{
    //     name:'shipped_containers',
    //     precision:10,scale:3,
    //     unsigned:true,
    // })
    // shipped_containers : number

    // @Column('decimal',{
    //     name:'exports_sales_amount',
    //     precision:10,scale:3,
    //     unsigned:true,
    // })
    // exportsSalesAmount : number

    // @Column('decimal',{
    //     name:'domestic_sale_amount',
    //     precision:10,scale:3,
    //     unsigned:true,
    // })
    // domesticSaleAmount : number

    // @Column('decimal',{
    //     name:'sales_returns',
    //     precision:10,scale:3,
    //     unsigned:true,
    // })
    // salesReturns : number


    @Column('varchar',{
        name:'column_name',
        length:50,
        nullable:false
    })
    columnName : string

    @Column('decimal',{
        name:'value',
        precision:10,scale:3,
        unsigned:true,
        nullable:false
    })
    value: number

    @Column('varchar',{
        name:'type',
        length:50,
        nullable:false
    })
    type : string

    @Column('varchar',{
        name:'ref_table',
        nullable:false,
        length:50
    })
    refTable : string

    @Column('int',{
        name:'ref_id',
        nullable:false
    })
    refId: number

    @Column('int',{
        name:'plant_id',
        nullable:false
    })
    plantId: number

    @Column('datetime',{
        name:'date',
        nullable:false
    })
    date: Date
    
}